<template>
  <main>
    <div class="block">
      <div class="page-title">
        <h2>
          <a href="#" title="中央內容導盲磚" accesskey="C">:::</a>即時影像
        </h2>
        <div class="bread">
          <router-link to="/">首頁</router-link><span>/</span>
          <router-link to="/monitor/cctvTable">監控資訊</router-link>
          <span>/</span>
          <router-link to="/monitor/cctvTable">即時影像</router-link>
        </div>
      </div>
    </div>
    <div class="block bg-gradual">
      <div class="inner container">
        <div class="select-bar">
          <label for="type">單位：</label>
          <select v-model="selected.type" id="type" title="selected_type">
            <option v-for="item in option.type" :key="item" :value="item" v-once>{{ item }}</option>
          </select>
          <label for="county">縣市：</label>
          <select id="county" v-model="selected.county">
            <option :value="null">全縣市</option>
            <option v-for="item in option.county" :value="item" :key="item.ID" v-once>{{ item.Name }}</option>
          </select>
        </div>
        <div class="news-list-table">
          <div class="data-time">資料產出時間： {{ localTime }}</div>
          <div class="s-table">
            <table>
              <thead>
                <tr>
                  <th id="a" class="width-10pct">排序</th>
                  <th id="b" class="width-45pct">縣市</th>
                  <th id="c" class="width-45pct">名稱</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in list" :key="item.ID">
                  <td headers="a">{{ i + 1 }}</td>
                  <td headers="b">{{ item.Counname }}</td>
                  <td headers="c">
                    <span class="pointer" @click="showMonitor(item)">{{ item.Name }}</span>
                  </td>
                </tr>
                <tr v-show="list.length == 0" class="text-center" >
                  <td headers="a b c" colspan="3">無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div id="divWall" @click="closeWall()"></div>
    <div id="divMonitor">
      <button aria-label="close" @click="closeWall()">x</button>
      <div id="cctv-camera"></div>
      <div id="cctv-images">
        <img :src="imageUrl" :alt="`${displayName}即時影像`" :title="`${displayName}即時影像`" width="350" height="200" />
      </div>
      <div>{{ displayName }}</div>
    </div>
    <loading :active.sync="isLoading"></loading>
    <commonfunctions></commonfunctions>
  </main>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import commonfunctions from "../shared/commonfunctions";
import county from "../../../public/json/County.json";
import { cctv } from "../../../public/js/helper.js";

const getTwoDigit = number => number.toString().padStart(2, '0');
let imageInterval = null;
let cctvData = { water: [], road: [], other: [] };

export default {
  metaInfo: {
    title: "經濟部水利署防災資訊網-監控資訊-即時影像資料",
  },
  components: {
    Loading,
    commonfunctions,
  },
  data() {
    return {
      isLoading: false,
      displayName: "",
      imageUrl: "",
      localTime: "",
      option: {
        type: Object.values(cctv.typeEnum),
        county: county.map(a => ({Name:a.Name, ID:a.ID, Order: a.Order})).sort((a,b) => a.Order - b.Order)
      },
      selected: {
        type: cctv.typeEnum.water,
        county: null
      }
    };
  },
  mounted() {
    let my = this;
    document.onkeydown = function (event) {
      let key = window.event.keyCode;
      if (
        key == 27 &&
        $("#divWall").hasClass("myBlur") &&
        !my.isLoading &&
        !my.$parent.isCheckingImg
      ) {
        my.closeWall();
      }
    };

    let date = new Date();
    this.localTime = `${date.getFullYear()}-${getTwoDigit(date.getMonth() + 1)}-${getTwoDigit(date.getDate())} ${getTwoDigit(date.getHours())}:${getTwoDigit(date.getMinutes())}`;

    this.initCCTVData();
  },
  computed: {
    list(){
      let result = [];

      switch (this.selected.type) {
        case cctv.typeEnum.water:
          result = this.selected.county ? cctvData.water.filter(a => a.Counname == this.selected.county.Name) : cctvData.water;
          break;
        case cctv.typeEnum.road:
          result = this.selected.county ? cctvData.road.filter(a => a.Counname == this.selected.county.Name) : cctvData.road;
          break;
        case cctv.typeEnum.other:
          result = this.selected.county ? cctvData.other.filter(a => a.Counname == this.selected.county.Name) : cctvData.other;
          break;
      }
      return result;
    }
  },
  methods: {
    async initCCTVData() {
      this.isLoading = true;

      let response = (await this.$http.get("https://fhyv.wra.gov.tw/FhyWeb/v1/Api/CCTV/WRA/Station?$format=JSON")).data;

      cctvData.water.push(...response.filter(item => item.SourceId == 1 || item.SourceId == 3 || item.SourceId == 10 || item.SourceId == 20 || item.SourceId == 21));
      cctvData.road.push(...response.filter(item => item.SourceId == 11));
      cctvData.other.push(...response.filter(item => item.SourceId == 22));

      this.isLoading = false;
    },
    async showMonitor(station){
      $("#divMonitor").css("display", "block");
      $("#divWall").addClass("myBlur");
      
      this.displayName = `${station.Counname}-${station.Name}`;
      this.isLoading = true;
      
      // let responseData = (await this.$http.get(`https://fhyv.wra.gov.tw/FhyWeb/v1/Api/CCTV/WRA/Cameras/${station.SourceId}/${station.ID}`)).data;
      let url = `https://fhyv.wra.gov.tw/FhyWeb/v1/Api/CCTV/WRA/Cameras/${encodeURIComponent(station.SourceId)}/${encodeURIComponent(station.ID)}`
      let urlObj = new URL(url);
      let responseData = (await this.$http.get(urlObj.toString())).data;
      // 验证返回的数据结构
      if (!(Array.isArray(responseData) && responseData.length > 0 && responseData[0].cameras)) return false;
      let camera = responseData[0].cameras[0];
      let imageIndex = 0;

      clearInterval(imageInterval);

      if(camera.images){
        let interval = () => {
          this.imageUrl = camera.images[imageIndex++];
          if(imageIndex >= camera.images.length) imageIndex = 0;
          this.isLoading = false;
        };
        imageInterval = setInterval(interval, 1000);
      }else if(camera.video){
        $("#cctv-camera").html(`<iframe style="width:352px; !important;height:240px; !important;" src="https://www.youtube.com/embed/${camera.video[0]}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="true"></iframe>`);
        this.isLoading = false;
      }
    },
    closeWall() {
      $("#divMonitor").css("display", "none");
      $("#divWall").removeClass("myBlur");
      $("#cctv-camera").html("");

      this.imageUrl = ""
      clearInterval(imageInterval);
    },
  }
};
</script>

<style scoped>
#divMonitor{
  z-index: 1001;
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -186px;
  margin-top: -120px;
  color: black;
  display: none;
  border-width: 0.5px;
  border-color: black;
  padding: 25px 10px 10px;
}
#divMonitor button{
  position: absolute;
  top: 0;
  right: 0;
}
#cctv-images img{
  max-width: 352px; 
  max-height: 240px;
}
.select-bar label{
  margin-left: 20px;
}
select option{
  color: black;
}
.width-10pct{
  width: 10%;
}
.width-45pct{
  width: 45%;
}
</style>